const grads = [
    { id: 1101, periodid: '1001', name: '一年级' },
    { id: 1102, periodid: '1001', name: '二年级' },
    { id: 1103, periodid: '1001', name: '三年级' },
    { id: 1104, periodid: '1001', name: '四年级' },
    { id: 1105, periodid: '1001', name: '五年级' },
    { id: 1106, periodid: '1001', name: '六年级' },
    { id: 1107, periodid: '1003', name: '七年级' },
    { id: 1108, periodid: '1003', name: '八年级' },
    { id: 1109, periodid: '1003', name: '九年级' },
    { id: 1111, periodid: '1005', name: '高一' },
    { id: 1112, periodid: '1005', name: '高二' },
    { id: 1113, periodid: '1005', name: '高三' }
]

export default grads


// WEBPACK FOOTER //
// ./src/data/grads.js